<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" routerLink="/user/background-exports">My Exports</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto"> </span>

      <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options.">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="listDataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="listDataSource.search"
          name="search"
          placeholder="Search file name"
          aria-label="Search"
          matTooltip="Search for exports by the generated file name." />

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          matTooltip="Click this button to run the current search.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
    </div>
  </nav>

  <div class="mat-elevation-z8 scroll-box">
    <mat-paginator
      #paginator1
      [length]="listDataSource?.total | async"
      [pageSize]="listDataSource.limit"
      [pageSizeOptions]="listDataSource.pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>

    <table mat-table [dataSource]="listDataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>

      <ng-container matColumnDef="feature">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by feature.">
          Feature
        </th>
        <td mat-cell *matCellDef="let row">
          {{ row.feature | titlecase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="format">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by format.">
          Format
        </th>
        <td mat-cell *matCellDef="let row">
          {{ (row.format || '') | uppercase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by status.">
          Status
        </th>
        <td mat-cell *matCellDef="let row" [ngSwitch]="row.status">
          <span *ngSwitchCase="'queued'" class="text-muted">
            <mat-icon class="align-middle">hourglass_empty</mat-icon> Queued
          </span>
          <span *ngSwitchCase="'processing'" class="text-blue">
            <mat-icon class="align-middle">sync</mat-icon> Processing
          </span>
          <span *ngSwitchCase="'completed'" class="text-green">
            <mat-icon class="align-middle">check_circle</mat-icon> Completed
          </span>
          <span *ngSwitchCase="'failed'" class="text-red">
            <mat-icon class="align-middle">error_outline</mat-icon> Failed
          </span>
          <span *ngSwitchDefault>{{ row.status | titlecase }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="file_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by file name.">
          File Name
        </th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row.file_name; else noFileName">
            {{ row.file_name }}
          </ng-container>
          <ng-template #noFileName>
            <span class="text-muted">Pending</span>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by date created.">
          Requested
        </th>
        <td mat-cell *matCellDef="let row">
          {{ (row.date_created * 1000) | timezoneConvertLong }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="180">
          Actions
        </th>
        <td mat-cell *matCellDef="let row">
          <button
            type="button"
            mat-button
            *ngIf="row.status === 'completed' && row.file_url"
            (click)="onDownload(row)"
            matTooltip="Download the exported file.">
            <mat-icon>cloud_download</mat-icon> Download
          </button>
          <button
            type="button"
            mat-button
            color="warn"
            *ngIf="row.status === 'failed'"
            (click)="onShowFailureReason(row)"
            matTooltip="View why this export failed.">
            <mat-icon>info_outline</mat-icon> Details
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
    </table>

    <div *ngIf="(listDataSource?.total | async) === 0" class="p-3 text-center text-muted">
      No exports yet. When you trigger a CSV, XLSX, or PDF export, it will appear here.
    </div>

    <mat-paginator
      #paginator2
      [length]="listDataSource?.total | async"
      [pageSize]="listDataSource.limit"
      [pageSizeOptions]="listDataSource.pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>
  </div>

</div>
